const API_URL = process.env.REACT_APP_API_URL;

interface ClientOptions extends RequestInit {
  data?: any;
  token?: string;
}

async function client(endpoint: string, options: ClientOptions = {}) {
  const customOptions = buildRequestOptions(options);
  const URL = `${API_URL}${endpoint}`;

  return fetch(URL, customOptions).then(async response => {
    let data;

    if (options.method === 'DELETE') {
      // Successful DELETE operations don't return a body according to Fernando
      if (response.ok) {
        return await response.text();
      }

      const data = await response.json();
      return Promise.reject({
        ...errorTransformer(data.error ?? data),
        status: response.status,
      });
    }

    data = await response.json();

    if (response.ok) return data;

    return Promise.reject({
      ...errorTransformer(data.error ?? data),
      status: response.status,
    });
  });
}

function buildRequestOptions({
  data,
  token,
  headers: customHeaders,
  ...customOptions
}: ClientOptions = {}) {
  return {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...customHeaders,
    },
    ...customOptions,
  };
}

function errorTransformer(error: unknown) {
  if (typeof error === 'object') {
    return error;
  }

  return { message: error };
}

export { client };
